import { render, staticRenderFns } from "./PaintColorComparison.vue?vue&type=template&id=234fa834&scoped=true"
import script from "./PaintColorComparison.vue?vue&type=script&lang=js"
export * from "./PaintColorComparison.vue?vue&type=script&lang=js"
import style0 from "./PaintColorComparison.vue?vue&type=style&index=0&id=234fa834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234fa834",
  null
  
)

export default component.exports